import { Link } from "react-router-dom";
import { SITE_IMAGES } from "@/lib/siteAssets";

export default function BioconFooter() {
  const scrollUp = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="bg-[#f1f7fc] pt-12 pb-8 border-t border-gray-100">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 mb-8">
          <Link to="/" className="flex items-center gap-2">
            <img
              src={SITE_IMAGES.logo}
              alt="Biocon"
              className="h-8 w-auto"
            />
            <span className="text-sm font-semibold text-[#2c4964]">Biocon</span>
          </Link>
        </div>

        <div className="border-t border-gray-200 pt-6 text-center">
          <p className="text-sm text-gray-500">
            &copy; 2010-2026 <strong className="text-[#2c4964]">Medicinal Bioconvergence Research Center</strong>. All rights reserved.
          </p>
        </div>
      </div>

      {/* Scroll to top */}
      <button
        onClick={scrollUp}
        className="fixed bottom-6 right-6 z-50 w-10 h-10 flex items-center justify-center rounded-md bg-[#1977cc] text-white hover:bg-[#1669b3] transition-colors cursor-pointer shadow-md"
        aria-label="Scroll to top"
      >
        <i className="ri-arrow-up-line text-lg" />
      </button>
    </footer>
  );
}
